import { GrcNotify, NotifyType } from '@grc/ui-package';
import { businessEntityUrl } from '../../common/constants/url-constants';

export default async function fetchLocationGeoFenceDetails(
  carrierId: string,
  fetchData: any,
  notify: any,
  tenantService: any
) {
  try {
    const response = await fetchData(
      `${businessEntityUrl}?entityId=${carrierId}`,
      notify,
      tenantService
    );
    if (response.status === 200) {
      const geoFenceData = response?.data?.[0]?.geofences;
      return geoFenceData;
    }
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
  }
}
